/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { AbstractControl, FormGroup } from '@angular/forms';

/* According to angular source code when the status of any control of form group is pending
 * (on pending status form.invalid === false and form.valid === false)
 * the form group status is pending aswell, even if status of any control is invalid.
 * So we decided to implement a function that will return true if any of nested controls is invalid.
 */

export const isFormGroupInvalid = (form: FormGroup | AbstractControl | null): boolean => {
  if (!form) return true;
  if (form.valid) return false;
  if (form.invalid) return true;
  if (!(form instanceof FormGroup)) return form.invalid;
  return Object.keys(form.controls).some((key) => isFormGroupInvalid(form.get(key)));
};
